import React__default, { Children, isValidElement, cloneElement } from 'react';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../../components/FormContent.js';

function StickyTabItem(_ref) {
  var id = _ref.id,
    children = _ref.children,
    logData = _ref.logData,
    onClick = _ref.onClick;
  if (!id || id.length === 0) {
    return jsx(EditorPlaceholder, {
      icon: jsx(BsPlus, null),
      message: "\uD0ED \uC544\uC774\uD15C id\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694."
    });
  }
  return jsx(React__default.Fragment, null, Children.map(children, function (child) {
    if (! /*#__PURE__*/isValidElement(child)) {
      return child;
    }
    return /*#__PURE__*/cloneElement(child, {
      id: id,
      logData: logData,
      onClick: onClick
    });
  }));
}

export { StickyTabItem };
//# sourceMappingURL=StickyTabItem.js.map
